module.exports = __webpack_public_path__ + "media/assets/images/flags/aw-a5dab7f317fc0b274e85b98f6b3efabb.svg";